module.exports = __webpack_public_path__ + "static/media/LAND.27b2aeb4.svg";